import {Switch, Route } from 'react-router-dom'
import PageLayout from '../layouts/PageLayout'

function Routes({ pageSummaries, pageNavbar, pageLocales, currentLocale }) {
    return (
        <>
         <Switch>
                <Route
                    exact 
                    path="/:locale" 
                    render={props => <PageLayout {...props} pageSummaries={pageSummaries} pageNavbar={pageNavbar} isHome locales={pageLocales} currentLocale={currentLocale} />
                } />
                <Route 
                    exact 
                    path="/:locale/:slug" 
                    render={props => <PageLayout {...props} pageSummaries={pageSummaries} pageNavbar={pageNavbar} locales={pageLocales} currentLocale={currentLocale} />
                } />
                <Route 
                    exact 
                    path="/:locale/:parentslug/:slug" 
                    render={props => <PageLayout {...props} pageSummaries={pageSummaries} pageNavbar={pageNavbar} locales={pageLocales} currentLocale={currentLocale} />
                } />
         </Switch>
           
        </>
    )
}

export default Routes
